export function normalizeTotpQrCodeSrc (qrCode: string): string {
  const trimmed = qrCode.trim()

  if (trimmed.startsWith('data:')) {
    return trimmed
  }

  if (trimmed.startsWith('<svg')) {
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(trimmed)}`
  }

  return trimmed
}
